export default __webpack_public_path__ + "static/media/top-games-img-two.06f57176.png";